import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-[#060919] relative border-t border-white/5 overflow-hidden" data-id="element-146">
      {/* Mystical glow behind pricing */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-yellow-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-147"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-150">
            Recupera tu paz y tu poder{' '}
            <span className="text-yellow-400" data-id="element-151">hoy mismo</span>.
          </h2>
          <p className="text-xl text-gray-300" data-id="element-152">
            Obtén la Guía Maestra + Los 3 Bonos Exclusivos por un precio de
            lanzamiento único.
          </p>
        </div>

        <div className="bg-gradient-to-b from-[#1a1f3a] to-[#0a0e27] border-2 border-yellow-500/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.15)] relative" data-id="element-153">
          {/* Badge */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-yellow-600 text-slate-900 font-bold px-6 py-2 rounded-full shadow-lg whitespace-nowrap" data-id="element-154">
            OFERTA DE LANZAMIENTO
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10 mt-4" data-id="element-155">
            <div className="text-center md:text-left" data-id="element-156">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-157">
                Acceso Total e Inmediato
              </h3>
              <ul className="space-y-2 text-gray-300" data-id="element-158">
                <li className="flex items-center justify-center md:justify-start" data-id="element-159">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-160" /> Guía
                  Maestra (3 Días)
                </li>
                <li className="flex items-center justify-center md:justify-start" data-id="element-161">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-162" /> Bono
                  1: Baños y Despojos
                </li>
                <li className="flex items-center justify-center md:justify-start" data-id="element-163">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-164" /> Bono
                  2: Manifestación
                </li>
                <li className="flex items-center justify-center md:justify-start" data-id="element-165">
                  <ShieldCheck className="w-5 h-5 text-yellow-400 mr-2" data-id="element-166" /> Bono
                  3: Escudo 60 Segundos
                </li>
              </ul>
            </div>

            <div className="text-center bg-black/30 p-6 rounded-2xl border border-white/5 min-w-[250px]" data-id="element-167">
              <div className="text-gray-400 text-lg mb-1" data-id="element-168">
                Precio Regular:{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-169">
                  $67 USD
                </span>
              </div>
              <div className="text-sm text-yellow-400 font-semibold mb-2" data-id="element-170">
                Hoy por solo:
              </div>
              <div className="text-6xl font-black text-white mb-2 tracking-tight" data-id="element-171">
                $17
              </div>
            </div>
          </div>

          <div id="pricing-cta" className="text-center scroll-mt-8" data-id="element-172">
            <Button size="lg" href="https://tumentesoberana.com/cart/45641248833593:1" className="w-full md:w-auto md:px-16 py-5 text-xl mb-6" data-id="element-173">
              ¡SÍ, QUIERO LIBERAR MI ENERGÍA AHORA!
            </Button>

            <div className="flex items-center justify-center text-gray-400 text-sm space-x-2" data-id="element-174">
              <Lock className="w-4 h-4" data-id="element-175" />
              <span data-id="element-176">
                Acceso instantáneo y seguro. Tu privacidad está garantizada.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}